import { useState } from 'react';
import { getRelativeTime } from '../../../helpers/getRelativeTime';
import type { FeedPost } from '../../../interfaces/feed.interface';
import { AuthorAvatar } from '../../AuthorAvatar';
import './card.component.scss';

interface CardComponentHeaderProps {
  subheader: string;
  edited: number;
  username: string;
  titleVersions: string[];
  post: FeedPost;
  userId?: string;
}

export default function CardComponentHeader(props: CardComponentHeaderProps) {
  const { subheader, edited, username, titleVersions, post, userId } = props;
  const [openEditedModal, setOpenEditedModal] = useState(false);

  const handleClickClose = () => {
    setOpenEditedModal(false);
  };

  return (
    <section className="USER__FEED__ITEM__HEADER">
      <div style={{ display: 'flex', gap: '12px' }}>
        <AuthorAvatar
          userId={post?.author?.authorId}
          username={post?.author?.username ?? ''}
          avatar={post?.author?.avatarUrl || ''}
          displayName={post?.author?.displayName || ''}
          currentUsername={username}
          currentUserId={userId}
          size="large"
          showName={false}
        />
      </div>
      <div className="METADATA">
        <span className="author-username">@{post?.author?.username}</span>
        <span className="PUBLISHED__ON">
          {getRelativeTime(post?.createdAt)}
        </span>
      </div>
    </section>
  );
}
